import { Component } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { GlGraphqlQueries } from 'src/app/shared/services/graphql/graphql.queries';
import { GraphqlService } from 'src/app/shared/services/graphql/graphql.service';
import { __updateExperiences } from 'src/app/shared/states/experiences/experiences.actions';

@Component({
  selector: 'app-template-example',
  templateUrl: './template-example.component.html',
  styleUrls: ['./template-example.component.scss']
})
export class TemplateExampleComponent {
  experienceData: any = null;
  routeExperienceId: string | null = null;
  loadingState: boolean = false;
  protected ngUnsubscribe: Subject<void> = new Subject<void>();
  constructor(
    private graphqlService: GraphqlService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private toastr: ToastrService,
    private store: Store<any>,
  ) {

    this._activatedRoute.parent?.parent?.paramMap
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((params: ParamMap) => {
        if (params.get('id_experience')) {
          this.routeExperienceId = params.get('id_experience');
        }
      });
  }

   /* Al iniciar el componente */
   ngOnInit(): void {
    if (this.routeExperienceId) {
      this.getExperience(); 
    }
  }

  getExperience() {

    // this.promotionForm.disable();
    this.experienceData = null;
    this.loadingState = true;

    this.graphqlService.getQuery(GlGraphqlQueries.experienceSingleQuery, {
      experienceId: this.routeExperienceId,
    })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (data) => {
          this.loadingState = false
          this.experienceData = data.data.getExperience;
          // this.propagateForm();

          // Propagar reducer
          this.store.dispatch(__updateExperiences(this.experienceData));
          // this.promotionForm.enable();
        },
        error: (error) => {

          this.loadingState = false;

          // this.toastr.error('Ha ocurrido un error desconocido, vuelve a intentarlo.', 'Error Obteniendo Experiencia', {
          //   progressBar: true,
          // });

          this._router.navigate(['../../list'], { relativeTo: this._activatedRoute });
        },
      });
  }
}
